<template>
  <div class="select">
    <div v-html="icon" class="option-icon" />
    <svg
      class="option-check"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
    >
      <path
        :class="checked ? 'option-checked' : 'option-unchecked'"
        fill-rule="evenodd"
        d="M12.5 25a12.5 12.5 0 1 0 0-25 12.5 12.5 0 0 0 0 25zm-2-6.6l9-8.9L18 8l-7.5 7.6-4-4.1L5 12.9l5.5 5.5z"
        clip-rule="evenodd"
      />
    </svg>
    <div class="option-title">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checked: false,
    icon: null,
    title: null
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('select', v)
      }
    }
  }
}
</script>

<style>
.options {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0.5em;
}
.option {
  position: relative;
  padding: 8px 8px 8px 1em;
  flex-grow: 1;
  width: 50%;
  max-width: 140px;
  height: 100px;
  background-color: #ffffff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 1px 2px rgba(0, 0, 0, 0.04),
    0px 1px 2px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  margin: 0 1em 1em 0;
  color: black;
}
.option:hover {
  cursor: pointer;
}
.option-title {
  position: absolute;
  left: 1em;
  bottom: 1em;
  color: #696e80;
}
.option-check {
  float: right;
}
.option-checked {
  fill: #2dc76d;
}
.option-unchecked {
  fill: rgba(0, 0, 0, 0.2);
}
.option-icon {
  display: inline-block;
}
</style>